import type { CreateCallStackResponse } from '@compass/client/types/call';
import { callService } from '@services/api';
import { useMutation } from '@tanstack/react-query';

import type { StackScope } from './useStackableCases';

export interface CreateCallStackVars {
  /** The case the call was placed from. */
  caseRecordId: string;
  /** The live call. This is the stack id. */
  callId: string;
  childCaseRecordIds: string[];
}

/**
 * Stacks cases onto the live call, under the scope captured when the dialpad
 * opened. The server re-checks every case inside its transaction and answers
 * per case, so a refusal arrives as a candidate reason, not as an error.
 */
export const useCreateCallStack = (scope: StackScope | null) =>
  useMutation<CreateCallStackResponse, Error, CreateCallStackVars>({
    mutationFn: vars => {
      if (!scope) return Promise.reject(new Error('No case scope for this call'));
      return callService.createCallStack({
        organization_id: scope.organizationId,
        program_id: scope.programId,
        case_record_id: vars.caseRecordId,
        call_id: vars.callId,
        child_case_record_ids: vars.childCaseRecordIds,
      });
    },
  });
